import { useParams } from "react-router-dom";
import { DisenioBodega } from "../../layout"
import { useMovimientosXBodega } from "../../../hooks";
import { Box } from "@mui/material";
import { BuscadorSoloValor, CargandoMedio } from "../../components";
import { TablaMovimientosStock } from "../../components/productos/inventario";






export const HistorialStockXBodega = () => {


    const { id } = useParams();
    const { movimientosXBodegaQuery, page, termino, chagePage, chageTermino } = useMovimientosXBodega(id);


    return (

        <DisenioBodega titulo="Historial Movimientos" add={false}>
            {(movimientosXBodegaQuery.isLoading)
            ?   <CargandoMedio titulo="Cargando Movimientos..." />
            :   <>
                <BuscadorSoloValor termino={termino} chageTermino={chageTermino} 
                    titulo='Buscar movimiento.' place='Buscar x producto'
                />
                <TablaMovimientosStock data={movimientosXBodegaQuery.data || []} page={page} chagePage={chagePage} />
                </>   
            
            }

            <Box sx={{height:30}} />
        </DisenioBodega>
    )
}
